"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.profession.select.label': 'Elija su profesión para comenzar el onboarding:',
    'onboarding.profession.select.placeholder': '-- Seleccionar Profesión --',
    'onboarding.profession.empty': 'No hay profesiones disponibles.',
};
